import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useEffect } from 'react';
import { useGetProfileQuery } from 'store/slices/profile-api';
import { setTheme } from 'store/slices/theme-slice';
import { EVENTS, SIGNUP_STEPS, trackEvent } from 'utils/analytics';
import WelcomeView from './WelcomeView';

export const Route = createFileRoute('/auth/signup/_layout/welcome')({
  component: Welcome,
});

function Welcome() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { data: userProfile } = useGetProfileQuery();

  useEffect(() => {
    setTimeout(() => {
      dispatch(setTheme('dark'));
    }, 3000);
  }, [dispatch]);

  function toDashboard() {
    trackEvent(EVENTS.REGISTRATION_COMPLETE, {
      step: SIGNUP_STEPS.DASHBOARD,
      userId: userProfile?.id ?? undefined,
    });
    navigate({ to: '/' });
  }

  return <WelcomeView toDashboard={toDashboard} />;
}
